import type { FC } from "react";

import { PackCodes as UIPackCodes } from "@jti/loyalty/components/PackCodes";

import type { packCodesInputs } from "./PackCodes.builder";

export type PackCodesBuilderProps = BuilderComponentProps<typeof packCodesInputs>;

export const PackCodes: FC<PackCodesBuilderProps> = (props) => {
  return <UIPackCodes {...props} />;
};
